import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator, Input, Operators } from '@townsquare/tql/types';

export const SHOW_LIMIT = 10;

const getBaseTql = (teamId: string): Input[] => [
	{
		fieldName: 'archived',
		comparator: ComparatorOperator.EQUALS,
		fieldValue: false,
	},
	{
		fieldName: 'team',
		comparator: ComparatorOperator.EQUALS,
		fieldValue: teamId,
	},
];

export const getActiveProjectsTql = (teamId: string): string =>
	tqlQueryFromInput({
		input: getBaseTql(teamId),
		doc: {
			model: [
				{
					model: ['on_track', 'at_risk', 'off_track'],
					comparator: ComparatorOperator.EQUALS,
					operator: Operators.OR,
					type: 'status_phase',
				},
			],
			operator: Operators.AND,
		},
	});

export const getPendingProjectsTql = (teamId: string): string =>
	tqlQueryFromInput({
		input: getBaseTql(teamId).concat({
			fieldName: 'status_phase',
			comparator: ComparatorOperator.EQUALS,
			fieldValue: 'pending',
		}),
	});

export const getPausedProjectsTql = (teamId: string): string =>
	tqlQueryFromInput({
		input: getBaseTql(teamId).concat({
			fieldName: 'status_phase',
			comparator: ComparatorOperator.EQUALS,
			fieldValue: 'paused',
		}),
	});

export const getCompletedProjectsTql = (teamId: string): string =>
	tqlQueryFromInput({
		input: getBaseTql(teamId).concat({
			fieldName: 'status_phase',
			comparator: ComparatorOperator.EQUALS,
			fieldValue: 'done',
		}),
	});

export const getRelatedGoalsTql = (teamId: string): string =>
	tqlQueryFromInput({
		input: getBaseTql(teamId).concat({
			fieldName: 'status_phase',
			comparator: ComparatorOperator.NOT_EQUALS,
			fieldValue: 'done',
		}),
	});
